import styled, { css } from "styled-components";

export const MaximumDailyDepositLimitWrapper = styled.div`
	display: flex;
	flex-direction: column;
	width: 100%;
	min-height: 156px;
	border-radius: 20px;
	background: var(--profile-page-wrapper-bg);
	padding: 15px 10px;
	gap: 10px;
	margin-bottom: 10px;

	/* Chrome, Safari, Edge, Opera */
	input::-webkit-outer-spin-button,
	input::-webkit-inner-spin-button {
		-webkit-appearance: none;
		margin: 0;
	}

	/* Firefox */
	input[type="number"] {
		-moz-appearance: textfield;
		appearance: textfield;
	}

	.ant-input {
		color: var(--content-text-color) !important;
		font-size: 12px !important;
		font-weight: 400 !important;
		line-height: 16px !important;
		letter-spacing: 0.3px !important;
		width: 100%;
		height: 40px;
		padding: 10px 5px 0 20px !important;
		border-radius: 50px;
		border: 1px solid var(--profile-card-text-color);
		background: var(--input-bg-has-value) !important;
	}

	.ant-input[disabled] {
		border: 1px solid var(--profile-card-text-color) !important;
	}

	.ant-input[disabled]:hover {
		border: 1px solid var(--profile-card-text-color);
	}
	.ant-form-item {
		margin-bottom: 0px;
		position: relative;

		.ant-form-item-label {
			position: absolute;
			z-index: 1;
			top: 5px;
			left: 21px;
			height: 12px;
			display: flex;
			align-items: center;

			& > label {
				color: var(--main-secondary-text-color);
				font-size: 10px;
				font-weight: 400;
				line-height: 12px;
				letter-spacing: 0.25px;
				height: 100%;
			}
		}

		&.switch-form-item {
			justify-content: center;
			.ant-form-item-label {
				position: relative;
				width: 85px;
			}
		}
	}

	${window.HAS_LESS_BORDER_RADIUS &&
	css`
		.ant-input {
			border-radius: 10px;
		}

		input {
			border-radius: 10px;
		}

		.ant-form-item textarea.ant-input {
			border-radius: 10px;
		}
	`}

	.two-factor-auth-container {
		color: var(--content-text-color);
		text-align: center;
		font-size: 10px;
		font-weight: 400;
		line-height: 12px;
		letter-spacing: 0.25px;
	}

	p {
		margin: 0 0 10px 0;
		min-height: 66px;
		padding: 0 10px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.two-factor-auth-exclude-btn {
		align-items: center;
		display: flex;
		width: 100%;
		justify-content: center;
		border-radius: 25px;

		${window.HAS_LESS_BORDER_RADIUS &&
		css`
			border-radius: 10px;
		`}

		background: var(--profile-card-button-bg);
		color: var(--button-color);
		opacity: 0.6;

		svg {
			path {
				fill: var(--button-color);
			}
		}
	}

	.ant-btn[disabled],
	.ant-btn[disabled]:hover,
	.ant-btn[disabled]:focus,
	.ant-btn[disabled]:active {
		background: var(--profile-card-button-bg);
		color: var(--button-color);
		opacity: 0.2;
	}
`;

export const DepositLimitSetButton = styled.button`
	display: flex;
	min-height: 40px;
	width: 100%;
	justify-content: center;
	align-items: center;
	gap: 10px;
	flex: 1 0 0;
	border: 1px solid var(--main-color);
	background: #0b0610;
	color: var(--main-color);
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 16px;
	letter-spacing: 0.75px;
	border-radius: 25px;
`;

export const DepositLimitInfo = styled.p`
	color: var(--content-text-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.3px;
	width: 100%;
	margin-top: 10px;
`;

export const Title = styled.div`
	color: var(--profile-card-text-color);
	text-align: center;
	font-size: 12px;
	font-weight: 600;
	line-height: 20px;
	letter-spacing: 0.3px;
`;

export const Description = styled.div`
	color: var(--content-text-color);
	text-align: center;
	font-size: 10px;
	font-weight: 400;
	line-height: 12px;
	letter-spacing: 0.25px;
`;
